// src/utils/contrasenaPropia.js
// La contraseña que crea una persona al entrar con una que le dieron (programa de Bienvenida, docs/planes/CURSOS_PLAN.md
// §0.1 #46: la de su carta, o la de "Nueva Pass" de un administrador): la que le dieron deja de servir. Es el ESPEJO de `errorContrasenaPropia` de functions/bienvenida/reglas.js
// (quien de verdad decide es el servidor); acá se revisa antes de mandarla, para avisar al instante, y se suma lo que solo
// el navegador sabe: que no sea la misma contraseña de la carta con la que acaba de entrar.
// Pruebas: contrasenaPropia.test.js.

export const LARGO_MINIMO = 8;
const LARGO_MAXIMO = 128;

/** Los requisitos, para mostrarlos con su marca de cumplido mientras la persona escribe. */
export function requisitosContrasena(p, { correo = '', contrasenaCarta = '' } = {}) {
  const clave = typeof p === 'string' ? p : '';
  const usuario = String(correo || '').trim().toLowerCase().split('@')[0];
  return [
    { id: 'largo', texto: `Al menos ${LARGO_MINIMO} caracteres`, ok: clave.length >= LARGO_MINIMO && clave.length <= LARGO_MAXIMO },
    { id: 'letrasNumeros', texto: 'Letras y números', ok: /[A-Za-zÁÉÍÓÚÜÑáéíóúüñ]/.test(clave) && /[0-9]/.test(clave) },
    { id: 'distinta', texto: 'Distinta a la que usaste para entrar', ok: !!clave && clave !== contrasenaCarta },
    {
      id: 'sinUsuario', texto: 'Sin tu usuario adentro',
      ok: !!clave && !(usuario.length >= 4 && clave.toLowerCase().includes(usuario)),
    },
  ];
}

/** null = sirve; si no, qué le falta, en palabras para la persona. */
export function errorContrasenaPropia(p, repetida, opciones = {}) {
  if (typeof p !== 'string' || !p) return 'Escribí tu contraseña nueva.';
  if (p !== p.trim()) return 'La contraseña no puede empezar ni terminar con un espacio.';
  if (/^(.)\1+$/.test(p)) return 'La contraseña no puede ser un mismo carácter repetido.';
  const falta = requisitosContrasena(p, opciones).find((r) => !r.ok);
  if (falta) {
    if (falta.id === 'largo') return p.length > LARGO_MAXIMO ? `La contraseña puede tener hasta ${LARGO_MAXIMO} caracteres.` : `La contraseña necesita al menos ${LARGO_MINIMO} caracteres.`;
    if (falta.id === 'letrasNumeros') return 'La contraseña necesita letras y números.';
    if (falta.id === 'distinta') return 'Tiene que ser distinta a la contraseña que usaste para entrar.';
    return 'La contraseña no puede llevar tu usuario adentro.';
  }
  if (p !== repetida) return 'Las dos contraseñas no coinciden.';
  return null;
}
